import { useGet } from './useHttpHooks';
import { Tag } from '../types';

type ChildTagsQuery = { tagId: string };

const useGetChildTags = (request: ChildTagsQuery) => {
    return useGet<Tag[]>(
        `/api/tags/${encodeURIComponent(request.tagId)}/children`,
        {
            errorMessage: 'GET /api/tags/{tagId}/children failed'
        }
    );
};

export default useGetChildTags;
